import React from 'react';
import PropTypes from 'prop-types';

const buildUnique = (entries) => {
    const seen = new Set();
    const result = [];
    entries.forEach(({ label, value }) => {
        if (value && !seen.has(value.toLowerCase())) {
            seen.add(value.toLowerCase());
            result.push({ label, value });
        }
    });
    return result;
};

const buildUniquePhones = (entries) => {
    const seen = new Set();
    const result = [];
    entries.forEach(({ label, value }) => {
        if (value && !seen.has(value)) {
            seen.add(value);
            result.push({ label, value });
        }
    });
    return result;
};

function RecipientSelector({
    userName, userPhone,
    patientName, patientPhone,
    addressName, addressPhone,
    recipientName, recipientPhone,
    onNameChange, onPhoneChange,
}) {
    const uniqueNames = buildUnique([
        { label: 'User', value: userName },
        { label: 'Patient', value: patientName },
        { label: 'Address', value: addressName },
    ]);

    const uniquePhones = buildUniquePhones([
        { label: 'User', value: userPhone },
        { label: 'Patient', value: patientPhone },
        { label: 'Address', value: addressPhone },
    ]);

    return (
        <div className='flex flex-col gap-[0.9rem]'>
            <hr />
            <div className='flex flex-col gap-[0.5rem]'>
                <label className='font-medium'>Recipient Name</label>
                <div className='flex gap-[0.5rem] flex-wrap'>
                    {uniqueNames.map(({ label, value }) => (
                        <button
                            key={label}
                            type='button'
                            onClick={() => onNameChange(value)}
                            className={`py-1 px-3 rounded-xl border-2 text-sm font-semibold transition-colors ${
                                recipientName === value
                                    ? 'border-[#28A48B] bg-[#e6f7f4] text-[#28A48B]'
                                    : 'border-gray-300 text-gray-700'
                            }`}
                        >
                            {label}: {value}
                        </button>
                    ))}
                </div>
                <input
                    type='text'
                    className='w-full'
                    value={recipientName}
                    onChange={(e) => onNameChange(e.target.value)}
                    placeholder='Or enter name manually...'
                />
            </div>
            <div className='flex flex-col gap-[0.5rem]'>
                <label className='font-medium'>Recipient Phone</label>
                <div className='flex gap-[0.5rem] flex-wrap'>
                    {uniquePhones.map(({ label, value }) => (
                        <button
                            key={label}
                            type='button'
                            onClick={() => onPhoneChange(value)}
                            className={`py-1 px-3 rounded-xl border-2 text-sm font-semibold transition-colors ${
                                recipientPhone === value
                                    ? 'border-[#28A48B] bg-[#e6f7f4] text-[#28A48B]'
                                    : 'border-gray-300 text-gray-700'
                            }`}
                        >
                            {label}: {value}
                        </button>
                    ))}
                </div>
                <input
                    type='text'
                    className='w-full'
                    value={recipientPhone}
                    onChange={(e) => onPhoneChange(e.target.value)}
                    placeholder='Or enter phone manually...'
                />
            </div>
        </div>
    );
}

RecipientSelector.propTypes = {
    userName: PropTypes.string,
    userPhone: PropTypes.string,
    patientName: PropTypes.string,
    patientPhone: PropTypes.string,
    addressName: PropTypes.string,
    addressPhone: PropTypes.string,
    recipientName: PropTypes.string.isRequired,
    recipientPhone: PropTypes.string.isRequired,
    onNameChange: PropTypes.func.isRequired,
    onPhoneChange: PropTypes.func.isRequired,
};

export default RecipientSelector;
